let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jdrxF")).then(() => parcelRequire('lTO3M'));